import Icon from "@ant-design/icons";
import { useSelector } from "react-redux";
const EyeSlashIconSVG = (props) => {
  const themeDefault = useSelector((state) => state.themeDefault);
  let themeValue = themeDefault?.info?.newConfig;
  const predefinedSizes = {
    small: { ...themeValue?.fontSmlSize?.size },
    medium: { ...themeValue?.fontMediumSize?.size },
    large: { ...themeValue?.fontLgSize?.size },
  };
  const { size, width, height } = props;
  const finalSize = predefinedSizes[size] || { width, height };
  return (
    <svg
      width={finalSize.width || "24"}
      height={finalSize.height || "24"}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.46992 15.2799C9.27992 15.2799 9.08992 15.2099 8.93992 15.0599C8.11992 14.2399 7.66992 13.1499 7.66992 11.9999C7.66992 9.60992 9.60992 7.66992 11.9999 7.66992C13.1499 7.66992 14.2399 8.11992 15.0599 8.93992C15.1999 9.07992 15.2799 9.26992 15.2799 9.46992C15.2799 9.66992 15.1999 9.85992 15.0599 9.99992L9.99992 15.0599C9.84992 15.2099 9.65992 15.2799 9.46992 15.2799ZM11.9999 9.16992C10.4399 9.16992 9.16992 10.4399 9.16992 11.9999C9.16992 12.4999 9.29992 12.9799 9.53992 13.3999L13.3999 9.53992C12.9799 9.29992 12.4999 9.16992 11.9999 9.16992Z"
        fill="currentColor"
      />
      <path
        d="M5.59984 18.51C5.42984 18.51 5.24984 18.45 5.10984 18.33C4.03984 17.42 3.07984 16.3 2.25984 15C1.19984 13.35 1.19984 10.66 2.25984 8.99998C4.69984 5.17998 8.24984 2.97998 11.9998 2.97998C14.1998 2.97998 16.3698 3.73998 18.2698 5.16998C18.5998 5.41998 18.6698 5.88998 18.4198 6.21998C18.1698 6.54998 17.6998 6.61998 17.3698 6.36998C15.7298 5.12998 13.8698 4.47998 11.9998 4.47998C8.76984 4.47998 5.67984 6.41998 3.51984 9.80998C2.76984 10.98 2.76984 13.02 3.51984 14.19C4.26984 15.36 5.12984 16.37 6.07984 17.19C6.38984 17.46 6.42984 17.93 6.15984 18.25C6.01984 18.42 5.80984 18.51 5.59984 18.51Z"
        fill="currentColor"
      />
      <path
        d="M12.0006 21.02C10.6706 21.02 9.37055 20.75 8.12055 20.22C7.74055 20.06 7.56055 19.62 7.72055 19.24C7.88055 18.86 8.32055 18.68 8.70055 18.84C9.76055 19.29 10.8706 19.52 11.9906 19.52C15.2206 19.52 18.3106 17.58 20.4706 14.19C21.2206 13.02 21.2206 10.98 20.4706 9.81C20.1606 9.32 19.8205 8.85 19.4606 8.41C19.2006 8.09 19.2506 7.62 19.5706 7.35C19.8906 7.09 20.3605 7.13 20.6306 7.46C21.0206 7.94 21.4006 8.46 21.7406 9C22.8006 10.65 22.8006 13.34 21.7406 15C19.3006 18.82 15.7506 21.02 12.0006 21.02Z"
        fill="currentColor"
      />
      <path
        d="M12.6896 16.2701C12.3396 16.2701 12.0196 16.0201 11.9496 15.6601C11.8696 15.2501 12.1396 14.8601 12.5496 14.7901C13.6496 14.5901 14.5696 13.6701 14.7696 12.5701C14.8496 12.1601 15.2396 11.9001 15.6496 11.9701C16.0596 12.0501 16.3296 12.4401 16.2496 12.8501C15.9296 14.5801 14.5496 15.9501 12.8296 16.2701C12.7796 16.2601 12.7396 16.2701 12.6896 16.2701Z"
        fill="currentColor"
      />
      <path
        d="M1.99945 22.75C1.80945 22.75 1.61945 22.68 1.46945 22.53C1.17945 22.24 1.17945 21.76 1.46945 21.47L8.93945 14C9.22945 13.71 9.70945 13.71 9.99945 14C10.2895 14.29 10.2895 14.77 9.99945 15.06L2.52945 22.53C2.37945 22.68 2.18945 22.75 1.99945 22.75Z"
        fill="currentColor"
      />
      <path
        d="M14.5307 10.2199C14.3407 10.2199 14.1507 10.1499 14.0007 9.99994C13.7107 9.70994 13.7107 9.22994 14.0007 8.93994L21.4707 1.46994C21.7607 1.17994 22.2407 1.17994 22.5307 1.46994C22.8207 1.75994 22.8207 2.23994 22.5307 2.52994L15.0607 9.99994C14.9107 10.1499 14.7207 10.2199 14.5307 10.2199Z"
        fill="currentColor"
      />
    </svg>
  );
};
const EyeSlashIcon = (props) => {
  const themeDefault = useSelector((state) => state.themeDefault);
  let themeValue = themeDefault?.info?.newConfig;
  const { size, color } = props;
  const predefinedSizes = {
    small: themeValue?.fontSmlSize,
    medium: themeValue?.fontMediumSize,
    large: themeValue?.fontLgSize,
  };
  return (
    <Icon
      component={EyeSlashIconSVG}
      style={{
        // color: color || themeDefault?.info?.newConfig?.color,

        fontSize: predefinedSizes[size] || predefinedSizes.medium,
      }}
      {...props}
    />
  );
};

export default EyeSlashIcon;
